module.exports = __webpack_public_path__ + "img/menu-mo.0bc87e8b.svg";